module.exports = __webpack_public_path__ + "media/images/gallery/constel-7c007981e19b43f410fb3effded988c1.gif";